// FrameX v1.0.1 - Force redeploy 2026-01-19
import { createRoot } from 'react-dom/client'
import { HashRouter } from 'react-router-dom'
import { ErrorBoundary } from 'react-error-boundary'
import App from './App.tsx'
import { ErrorFallback } from './ErrorFallback'
import { track } from './lib/track'
import "./main.css"
import "./styles/theme.css"
import "./index.css"
import "./styles/knaxly-override.css"

createRoot(document.getElementById('root')!).render(
    <ErrorBoundary
        FallbackComponent={ErrorFallback}
        onReset={() => window.location.reload()}
    >
        <HashRouter>
            <App />
        </HashRouter>
    </ErrorBoundary>
)

// Anonymous "app opened" signal (feeds the analytics funnel for direct visits).
track('opened')
